$(document).ready(function() {

  $("li.hover_mega_menu > a").click(function(e) {
    e.preventDefault();
    console.log("hello World");
    if($(this).parent('.hover_mega_menu').hasClass("hover")){
      $(this).parent('.hover_mega_menu').removeClass("hover");
    }else{
      $(".hover_mega_menu").removeClass("hover");
      $(this).parent('.hover_mega_menu').addClass("hover");
    }
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.desktop-megamenu').length && !$(event.target).closest('li.hover_mega_menu, li.hover_mega_menu *').length) {
      console.log("ok");
      $(".hover_mega_menu").removeClass("hover");
    }
  });

  $('.js-toggle-submenu-two').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass("active");
    $(this).next().slideToggle('500');
  });   
  // --------------------- Menu drop down
  
  // Search
  function open_search(){
    $(".search_model-bar").show();
    $('.header__search-model').addClass('open-model');
    $("#Search-In-Modal").trigger("focus");
  }
  
  function close_search(){
    $(".search_model-bar").hide();
    $('.header__search-model').removeClass('open-model');
    $('.search_toggle_button').removeClass('active');
  }

  $('body').click(function () {
    close_search();
  });
  $('.site-header .header__search,#menu-drawer-search').click(function(e) {
    e.stopPropagation();
  })

  $('.search_toggle_button').click(function(){
    $(this).toggleClass('active');
    if($(this).hasClass('active')){
      open_search();
    }else{
      close_search();
    }
  });
  $('.search_model-close').click(function(){
      close_search();
  });
  
  $("#Search-In-Modal").on("click", function() {
    setTimeout(open_search(),200);
    $('.site-nav__item--has-dropdown').removeClass('hover')
  });
  $(".search_model-bar .search_model-overlay").on("click", function() {
    close_search();
  });

  $('#Search-In-Modal').keyup(function() {
    var form = $(this).parents('form').serialize(); 
    fetch(`/search?${form}&section_id=header`).then(responseText => responseText.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      $('.search_model-bar .search_model-container').html($(html).find('.search_model-bar .search_model-container').html())
    });
  });

  $('#menu-drawer-search').click(function(){
    $('.slide-nav__overflow.js-menu--is-open .js-toggle-slide-nav').click();
    setTimeout(open_search(),200);
  }); 
  // --------------------- Search

  // Product page afterpay klarna popup
  $('.instalment-payment .instalment-payment-block').click(function() {
    var popup = $(this).data('title');
    $('.instalment-payment .'+popup).addClass('active');
  });
  $('.instalment-payment-popup .close,.instalment-payment-popup .instalment-payment-popup-overlay').click(function() {
    $(this).parents('.instalment-payment-popup').removeClass('active');
  });
 // --------------------- Product page afterpay klarna popup

  // Product Page Size popup
  $('#size-fit-popup-toggle,#size-fit-popup .size-fit-popup-overlayer,#size-fit-popup .close-size-fit').click(function() {
    $('#size-fit-popup').toggleClass('active');
  });
  // --------------------- Product Page Size popup

  $(document).on('change','.grid-product__content .product-grid-form .grid-product__colors input',function() {
    var id = $(this).data('id');
    var select_img = $(this).parents('.grid-product__content').find('.grid-product-variant-img img[data-id="'+id+'"]');
    if(select_img != ''){
      $(this).parents('.grid-product__content').find('.grid-product-variant-img img').removeClass('active');
      $(this).parents('.grid-product__content').find('.grid-product-variant-img').addClass('active');
      select_img.addClass('active');
    }
  });
  

  // Product grid form submit
  $(document).on('change','.grid-product__content .product-grid-form .select-wrap select',function() {
    var select = $(this)
    var val = $(this).val();
    var arr = [];
    if(val != 'default'){
      $(this).parents('.product-grid-form').find('.grip-product--option').each(function() {
        if($(this).find('input').length){
          arr.push($(this).find('input:checked').val());
        }else{
          arr.push($(this).find('select').val());
        }
      });
      arr = arr.join(' / ');
      var id = $(this).parents('.product-grid-form').find('[data-product-select] option[data-title="'+arr+'"]').val();
      $(this).parents('.product-grid-form').find('[data-product-select]').val(id).change();
      if($(this).parents('.product-grid-form').find('[data-product-select] option[data-title="'+arr+'"]').is(':disabled')){ 
        $(this).parents('.product-grid-form').find('.not-available').removeClass('hide');
        setTimeout(function(){$('.product-grid-form .not-available').addClass('hide');},1500);
      }else{
        $(this).parents('.product-grid-form').find('[data-add-to-cart]').click();
        setTimeout(function(){Rebuy.SmartCart.show();},1200);
      }
      setTimeout(function(){select.val('default').trigger('change');},1000);
    }
  });

  $(document).on('submit','.grid-product__content .product-grid-form form',function(e) {
    e.preventDefault();
    let formData = $(this).serialize();
    fetch(theme.routes.cartAdd, {
      method: "POST",
      body: formData,
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(response => response.json())
    .catch((error) => {
      console.error('Error:', error);
    });
  });

  // --------------------- Product grid form submit


  // product page mobile size selector
  if($('.select-size-drop-down-menu-wrap').length > 0){
    $(document).on('change','.select-size-drop-down-menu-wrap #select-size-drop-down-menu',function(){
      var val = $(this).val();
      $(this).parents('.select-size-drop-down-menu-wrap').next('.variant-input-wrap').find('input[value="'+ val +'"]').next('label').click();
      console.log(val);
    });
  }


  // --------------- fit finer

  function openCity(cityName) {
    var i;
    var x = document.getElementsByClassName("city");
    for (i = 0; i < x.length; i++) {
      x[i].style.display = "none";
    }
    document.getElementById(cityName).style.display = "block";
  }

  // product page popup js

  $(".find_fit-toggle,.modal-close,#modal-find-your-fit, #form-button-continue").click(function (e) {
      e.preventDefault();
      $("#modal-find-your-fit").toggleClass("active");
  });

    $("#modal-find-your-fit .modal-dialog").click(function(e){
    e.stopPropagation();
  });
  
  $('.desktop-megamenu').click(function(event){
      if (event.target === this) {
          $(this).parents('.site-nav__item').removeClass('hover');
      }
  });
});


